import storage from '@/plugins/localStorage'
import store from '@/store';
import {TimeoutError} from '@/plugins/errors.js'

const connectionStorage =  {

    connections_key: "sbs_local_connections",
    current_connection_key: "sbs_local_current_connection",
    lock_key: "sbs_local_connections_lock",
    lock_ttl: 10*1000,
    status_key: "sbs_local_connection_refresh_status",

    getConnections() {
        let connections = localStorage.getItem(this.connections_key);

        if (connections !== null) {
            //пытаемся конвертировать из строки в объект
            try {
                connections = JSON.parse(connections);
            } catch (e) {
                connections = {};
            }
        } else {
            connections = {};
        }

        return connections;
    },

    getCurrentConnectionKey() {
        let value = localStorage.getItem(this.current_connection_key);
        return value;
    },

    getConnection() {
        let connections = this.getConnections();
        let curentConnection = this.getCurrentConnectionKey();
        return connections[curentConnection] ? connections[curentConnection] : false;
    },

    getAccessToken() {
        let connection = this.getConnection();
        return connection ? connection.access_token : null;
    },

    getRefreshToken() {
        let connection = this.getConnection();
        return connection ? connection.refresh_token : null;
    },

    getApiUrl() {
        let connection = this.getConnection();
        return connection ? "https://" + connection.server + "/app/sbs/rest/" : "";
    },

    getServer() {
        let connection = this.getConnection();
        return connection ? connection.server : "";
    },

    isAuthorized() {
        let connection = this.getConnection();
        return connection ? true : false;
    },

    refreshAuthrorized(){
        store.commit('setIsAuthorized', this.isAuthorized());
    },

    setConnections(connections) {
        localStorage.setItem(this.connections_key, JSON.stringify(connections));
        this.refreshAuthrorized();
    },

    setCurrentConnection(key) {
        localStorage.setItem(this.current_connection_key, key);
        storage.set("current_connection", key);
        this.refreshAuthrorized();
    },

    updateConnection(value){

        let connections = this.getConnections();
        let curentConnection = this.getCurrentConnectionKey();
        connections[curentConnection] = value;
        this.setConnections(connections);

        storage.set("connections", connections);
    },

    addConnection(value) {

        let connections = this.getConnections();
        connections[value.server + "/" + value.login] = value;
        this.setConnections(connections);

        storage.set("connections", connections);

        this.refreshAuthrorized();
    },

    /**
     * Удаляет подключение
     */
    removeConnection(key) {
        let connections = this.getConnections();

        if (connections[key]) {
            delete connections[key];
            this.setConnections(connections);
            storage.set("connections", connections);
        }

        this.refreshAuthrorized();
    },

    /**
     * Сброс подключений
     */
    clear() {

        //очищаем подключения
        this.saveConnections({});
        this.setCurrentConnection(0);

        storage.set("connections", {});

        this.refreshAuthrorized();
    },

    startListenAuthUpdate() {

        //событие переключения вкладки из "неактивно" в "активно"
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
                //обновляем состояние авторизации
                this.refreshAuthrorized();
            }
        });
    },

    getLockDB() {

        return new Promise((resolve, reject) => {
            const request = indexedDB.open("SBS_Lock", 1);
            request.onupgradeneeded = (e) => {
                e.target.result.createObjectStore("locks", { keyPath: "key" });
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = reject;
        })
    },

    /**
     * Получает блокировку подключений
     */
    async getLock() {

        const db = await this.getLockDB();
        const tx = db.transaction("locks", "readwrite",{ durability: "strict" });
        const store = tx.objectStore("locks");

        const myId = `${Date.now()}_${Math.random()}`;

        const lock = {
            key: this.lock_key,
            owner: myId,
            ts: Date.now()
        };

        
        try {
            console.log("try get lock")

            await new Promise((resolve, reject) => {
                const req = store.add(lock);
                req.onsuccess = () => resolve();
                req.onerror = () => reject(req.error);
            });

            await new Promise((resolve, reject) => {
                tx.oncomplete = resolve;
                tx.onerror = () => reject(tx.error);
                tx.onabort = () => reject(tx.error);
            });

            return true;         
        } catch (e) {
            console.log("get lock failed")
            return false;             
        }

        
    },

    /**
     * Очистить блокировку
     */
    async releaseLock() {
        console.log("release lock")

        const db = await this.getLockDB();
        const tx = db.transaction("locks", "readwrite");
        const store = tx.objectStore("locks");

        try {
            await store.delete(this.lock_key);
            await tx.complete;
        } catch(e) {
            //todo
        }

    },

    /**
     * Ожидаем пока другая вкладка обновит токены
     */
    waitForTokenUpdate(timeout = 10000) {
        return new Promise((resolve, reject) => {
            const start = Date.now();
            let vm = this;

            function check() {
                const state = localStorage.getItem(vm.status_key);
                if (state === "success") {
                    // refresh завершён успешно
                    resolve();
                    return true;
                }

                if (state === "failed") {
                    // refresh завершился ошибкой
                    reject(new Error("Refresh token failed"));
                    return true;
                }

                return false;
            }

            function onStorage(e) {
                if (e.key === vm.status_key) {
                    if(check()) {
                        cleanup();
                    }
                }
            }

            // 1) Проверяем сразу — возможно refresh уже завершён
            if (check()) {
                return
            }

            // 2) Слушатель изменений localStorage
            window.addEventListener("storage", onStorage);

            // 3) Таймер безопасности — если вкладка зависла
            const interval = setInterval(() => {
                if (check()) {
                    cleanup();
                    return;
                }

                if (Date.now() - start > timeout) {
                    cleanup();
                    reject(new TimeoutError("Refresh token timeout"));
                }
            }, 200);

            function cleanup() {
                clearInterval(interval);
                window.removeEventListener("storage", onStorage);
            }

        });
    },

    setRefreshStatus(status) {
        localStorage.setItem(this.status_key, status);
    }
}

export default connectionStorage;